import { own, hasOwn } from "./memberDerive";

// Write permission and German hint for a conversation. Missing, malformed or inherited data is never a write permission.
const BLOCK_REASONS = { broadcast: "broadcast", group_paused: "group_paused", not_allowed: "not_allowed" };

export const WRITE_HINT = {
  broadcast: "Dies ist ein Kanal des VISIBILIS-Teams. Hier kannst du nur lesen.",
  group_paused: "Dieser Kreis ist vorübergehend pausiert. Neue Nachrichten sind gerade nicht möglich. Vorhandene Nachrichten kannst du weiterhin lesen.",
  not_allowed: "Du kannst in dieser Unterhaltung gerade nicht schreiben. Vorhandene Nachrichten kannst du weiterhin lesen.",
  unknown: "Ob du hier schreiben darfst, ist nicht bestätigt. Darum ist das Schreiben gesperrt. Vorhandene Nachrichten kannst du weiterhin lesen.",
  blocked: "Du hast dieses Mitglied blockiert. Es sind keine Nachrichten möglich.",
  not_accepted: "Nachrichten sind erst nach Annahme der Kontaktanfrage möglich.",
};

const writeResult = (reason) => ({ canWrite: reason === null, reason, hint: reason === null ? "" : WRITE_HINT[reason] });

// Direct: existing accepted/pending/block rules. Non-direct: broadcast never; otherwise only own can_write === true without an explicit block.
export function conversationWrite(conv, { blocked = false } = {}) {
  if (own(conv, "type") === "direct") {
    if (blocked) return writeResult("blocked");
    return writeResult(own(conv, "status") === "accepted" ? null : "not_accepted");
  }
  if (own(conv, "type") === "broadcast") return writeResult("broadcast");
  const block = own(conv, "write_block_reason");
  if (hasOwn(conv, "write_block_reason") && block !== null) {
    return writeResult(typeof block === "string" && Object.prototype.hasOwnProperty.call(BLOCK_REASONS, block) ? BLOCK_REASONS[block] : "unknown");
  }
  const can = own(conv, "can_write");
  return writeResult(can === true ? null : can === false ? "not_allowed" : "unknown");
}

export const CHAT_TEXT = {
  unclear: "Die Verbindung wurde unterbrochen. Ob die Aktion angekommen ist, ist unklar. Bitte lade die Ansicht neu und prüfe den Stand, bevor du es erneut versuchst.",
  write_forbidden: "Du darfst in dieser Unterhaltung gerade nicht schreiben. Vorhandene Nachrichten kannst du weiterhin lesen.",
  report_target_missing: "Der gemeldete Inhalt wurde nicht gefunden. Vielleicht wurde er schon entfernt.",
  failed: "Die Aktion konnte nicht ausgeführt werden. Bitte versuche es später erneut.",
};

const CHAT_KEY = {
  connection: "common.connection_error",
  not_found: "member.p2b.err_not_found",
  rate: "member.p2b.err_rate",
  cooldown: "member.p2b.err_cooldown",
  not_contactable: "member.p2b.err_not_contactable",
  pre_accept: "member.p2b.err_pre_accept",
};

// Error → stable code; never uses backend detail or err.message. A lost connection on an action is "unclear", never success.
export function chatErrorCode(err, { ctx = "", direct = true, connection = false } = {}) {
  if (connection) return ctx === "load" ? "connection" : "unclear";
  const s = own(own(err, "response"), "status");
  if (s === 404) return ctx === "report" ? "report_target_missing" : "not_found";
  if (s === 429) return ctx === "request" ? "cooldown" : "rate";
  if (s === 403 && ctx === "request") return "not_contactable";
  if (s === 403 && ctx === "message" && !direct) return "write_forbidden";
  if (s === 403 && ctx !== "report") return "pre_accept";
  return "failed";
}

export function chatErrorMessage(code, t) {
  if (Object.prototype.hasOwnProperty.call(CHAT_TEXT, code)) return CHAT_TEXT[code];
  return Object.prototype.hasOwnProperty.call(CHAT_KEY, code) ? t(CHAT_KEY[code]) : CHAT_TEXT.failed;
}
